import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import BeneficiosCard from './components/BeneficiosCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const BeneficiosMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Beneficios'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <BeneficiosCard />
        </Col>
      </Row>
    </Container>;
};

export default BeneficiosMain;
